




















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ReceptionCard extends Vue {
  @Prop(Object) reception: {};
  @Prop(Boolean) cardIsEmpty: false;
  @Prop() destinationId: undefined;

  /* Image fallback if card <img @error> is triggered */
  imageFallback (event: any) {
    event.target.src = "/img/placeholders/provider-placeholder.png";
  }
}
